// src/redux/stockerSignal/stockerSignalAPI.js
import apiClient from "../authentication/utils/core/axios";

const stockerSignalAPI = {
  async getStockerSignal(ticker, window = "30d") {
    // 🔥 CRITICAL FIX: prevent "undefined" API request
    if (!ticker || typeof ticker !== "string") {
      return null;
    }

    try {
      const response = await apiClient.get(
        `/stocker/${ticker}/signal`,
        { params: { window } }
      );
      return response.data;
    } catch (error) {
      console.warn("StockerSignalAPI getStockerSignal error:", error);
      throw error;
    }
  },
};

export default stockerSignalAPI;
